module.exports = __webpack_public_path__ + "img/sliceface.836c08df.png";